import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getPolicyCategoryList, removePolicyCategory } from "../../../services/ApiService";
import { api } from "../../../utils/api";
import { goToPage, promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import CustomTable from "../../components/CustomTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const PolicyCategorySettings = (props) => {
    const lang = props.lang;
    const history = useHistory();
    const location = useLocation();
    const tableColumns = [
        {
            Header: translate(lang, 'index'),
            accessor: (row, index) => {
                return index + 1;
            }
        },
        {
            Header: translate(lang, 'name'),
            accessor: (row, index) => {
                return row.name;
            }
        },
        {
            Header: translate(lang, 'type'),
            accessor: (row, index) => {
                return row.type;
            }
        },
        {
            Header: translate(lang, 'description'),
            accessor: (row, index) => {
                return row.description;
            }
        },
        {
            Header: translate(lang, 'level'),
            accessor: (row, index) => {
                return row.ringLevel;
            }
        },
        {
            Header: translate(lang, 'masterPolicy'),
            accessor: (row, index) => {
                return row.policy_master.name;
            }
        },
        {
            Header: translate(lang, 'icon'),
            accessor: (row, index) => {
                return <><img src={`${api.policyCategoryIcon + "/" + row.icon}`} alt="icon" className="rounded-2" width="50px" height="50px"></img></>;
            }
        },
        {
            Header: translate(lang, 'color'),
            accessor: (row, index) => {
                return (<><div className="color-box col-12" style={{ "--color-bg": row.color }}>{row.color}</div></>);
            }
        },
        {
            Header: translate(lang, 'action'),
            accessor: (row, index) => {
                return (<>
                    <div className="row">
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="button-tooltip-2">{translate(props.lang, "View Policy Category")}</Tooltip>}
                        >
                            {({ ref, ...triggerHandler }) => (
                                <div
                                    ref={ref} {...triggerHandler}
                                    onClick={()=>goToPage(`/settings/policy-category/view/${row.slug}`, pageNumber, productPerpage, filterInput)}
                                    // to={`/settings/policy-category/view/${row.slug}`}
                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                >
                                    <i className="fas fa-eye"></i>
                                </div>
                            )}
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="button-tooltip-3">{translate(props.lang, "Edit Policy Category")}</Tooltip>}
                        >
                            {({ ref, ...triggerHandler }) => (
                                <div
                                    ref={ref} {...triggerHandler}
                                    // to={`/settings/policy-category/edit/${row.slug}`}
                                    onClick={()=>goToPage(`/settings/policy-category/edit/${row.slug}`, pageNumber, productPerpage, filterInput)}
                                    className="btn btn-warning shadow btn-xs sharp me-1"
                                >
                                    <i className="fas fa-pen"></i>
                                </div>
                            )}
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="button-tooltip-4">{translate(props.lang, "Delete Policy Category")}</Tooltip>}
                        >
                            {({ ref, ...triggerHandler }) => (
                                <Link
                                    ref={ref} {...triggerHandler}
                                    onClick={() => removeItem(row.id)}
                                    className="btn btn-danger shadow btn-xs sharp me-1"
                                >
                                    <i className="fas fa-trash"></i>
                                </Link>
                            )}
                        </OverlayTrigger>
                    </div>
                </>)
            }
        },
    ]
    const [filterInput, setFilterInput] = useState(""); 
    const [pageNumber, setPageNumber] = useState(1);
    const [productPerpage, setProductPerpage] = useState(10);
    const [data, setData] = useState([]);
    const [fileData, setFileData] = useState({
        name: "member_list_report",
        excelData: [],
        hasCustom: false,
        customRows: [{
            customData: [],
            origin: -1, // last row or specified location like 'A1'
        }],
    });

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        let query = {};
        let res = await getPolicyCategoryList(query);
        if (res?.status === 'success') {
            setData([...res.data])
            setFileData([...res.data])
        } else {
        }
    }

    function removeItem(id) {
        Swal.fire({
            title: translate(props.lang, "delete"),
            text: translate(props.lang, "deleteMessage"),
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            dangerMode: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await removePolicyCategory(id)
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message)
                    getList();
                } else {
                    promptMessage(lang, 'error', res.message)
                    getList();
                }
            }
        })
    }

    return (
        <>
            <div className="card shadow">
                <div className="card-header">
                    <div>
                        <div  onClick={()=>goToPage(`/settings/policy-category/create`, pageNumber, productPerpage, filterInput)} className="btn btn-primary btn-sm rounded-2 py-2">{translate(lang, 'createPolicyCategory')}</div>
                    </div>
                </div>
                <div className="card-body">
                    <div id="job_data" className="dataTables_wrapper">
                        <CustomTable
                            lang={props.lang}
                            columns={tableColumns}
                            data={data}
                            excelExport={false}
                            fileData={fileData}
                            history={history}
                            location={location}
                            updatePageNumber={(page) => setPageNumber(page+1)}
                            updatePageLimit={(limit) => setProductPerpage(limit)}
                            pageNumber={pageNumber}
                            pageLimit={productPerpage}
                            updateFilter={(value) => setFilterInput(value)}
                            filterInput={filterInput}
                        ></CustomTable>
                    </div>
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(PolicyCategorySettings);